import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

function FacebookCallback() {
  const navigate = useNavigate();
  const login = useAuthStore(state => state.login);
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');
    const errorParam = searchParams.get('error');
    const messageParam = searchParams.get('message');

    if (errorParam) {
      setError(messageParam || 'Social authentication failed. Please try again.');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    if (token && userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));
        login(user, token);
        navigate('/');
      } catch (err) {
        console.error('Parse error:', err);
        setError('Authentication error. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    } else {
      setError('Missing authentication data.');
      setTimeout(() => navigate('/login'), 3000);
    }
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>❌ {error}</h2>
        <p>Redirecting to login...</p>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>🔄 Completing sign in...</h2>
      <p>Please wait while we authenticate your account.</p>
    </div>
  );
}

export default FacebookCallback;
